import { authProvider } from "../../authProvider";
import { Form, Input, Button, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { useNotification } from "@refinedev/core";
import { useLocation } from "react-router-dom";

const { Title } = Typography;

export default function AcceptInvite() {
  const { open } = useNotification();
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const token = params.get("token");
  const prefillEmail = params.get("email") ?? "";
  const prefillPassword = params.get("password") ?? "";
  const onSubmit = async ( values: { password: string }) => {
      if (authProvider?.acceptInvite) {
        const result = await authProvider.acceptInvite({
          token,
          newPassword: values.password
        });

        if (result.success) {
          open?.({
            type: "success",
            description: "Success",
            message: String(result.message) || "You have successfully accepted the invite.",
          });
          navigate("/login");
        } else {
          open?.({
            type: "error",
            message: "Error",
            description: String(result.message) || "Something went wrong. Please try again.",
          });
        }
      }
  }
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#000000",
      }}
    >
      <div
        style={{
          padding: "24px",
          borderRadius: "8px",
          backgroundColor: "#000000",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
          maxWidth: "400px",
          width: "100%",
          border: "1px solid gray"
        }}
      >
        <Title level={2} style={{ color: "rgb(232, 88, 82)", textAlign: "center", marginBottom: "24px" }}>
          Accept Invite
        </Title>
        <Form
          layout="vertical"
          onFinish={onSubmit}
          requiredMark={false}
        >
          <Form.Item
            label="New Password"
            name="password"
            rules={[
              { required: true, message: "Please input your new password!" },
              { min: 8, message: "Password must be at least 8 characters long." },
              { max: 64, message: "Password cannot exceed 64 characters." },
              { pattern: /[A-Za-z]/, message: "Password must contain at least one letter." },
              { pattern: /\d/, message: "Password must contain at least one number." },
            ]}
          >
            <Input.Password placeholder="Enter new password" />
          </Form.Item>
          <Form.Item
            label="Confirm Password"
            name="confirmPassword"
            rules={[
              { required: true, message: "Please confirm your new password!" },
            ]}
          >
            <Input.Password placeholder="Confirm new password" />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              style={{
                width: "100%",
                backgroundColor: "#e85852",
                color: "#ffffff",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#c44a46"; // Darker shade for hover
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#e85852"; // Original color
              }}
            >
              Reset Password
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};